exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = 127
// module chunks = 64